import React, { useCallback, useState } from "react";
import { Breadcrumbs } from "../../../AbstractElements";
import { FontAwesomeIcons, Icons } from "../../../Constant";
import { Container, Row } from "reactstrap";
import FontawesomeCommon from "./Common/FontawesomeCommon";
import { FONTAWESOME_ICONS } from "../../../Data/Icons";
import IconMarkUp from "../Icon-markup";

const FontawesomeIconContainer = () => {
  const [iTag, setiTag] = useState<string | object>("");
  const [icon, setIcon] = useState<string | object>("");

  const callback = useCallback((tag: string) => {
    setiTag({ iTag: '<i className="fa fa-' + tag + '"></i>' });
    setIcon({ icon: "fa fa-" + tag + " fa-2x" });
  }, []);

  return (
    <>
      <Breadcrumbs pageTitle={FontAwesomeIcons} parent={Icons} title={FontAwesomeIcons} />
      <Container fluid>
        <Row>
          {FONTAWESOME_ICONS.map((data, index) => (
            <FontawesomeCommon key={index} iconType={data.datas} title={data.title} parentCallback={callback} />
          ))}
        </Row>
        <IconMarkUp itag={iTag} icons={icon} />
      </Container>
    </>
  );
};

export default FontawesomeIconContainer;
